import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { hasAppApi } from '@egr/xbox/app-api/Communication';
import { LinkLikeText } from '@egr/xbox/egr-gui-elements/single-components/LinkLikeText';

interface CookieDialogTextProps {
    onLinkClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export const CookieDialogText: React.FC<CookieDialogTextProps> = React.memo(
    (props: React.PropsWithChildren<CookieDialogTextProps>) => {
        const { t } = useTranslation();

        return (
            <Typography>
                {hasAppApi ?
                    <Trans t={t}>
                        To guarantee the best experience for you, our application uses cookies. Please decide for yourself, which kind of cookies you want to allow. You will find further information in our <LinkLikeText onClick={props.onLinkClick} key="link">data privacy</LinkLikeText>.
                    </Trans> :
                    <Trans t={t}>
                        To guarantee the best experience for you, our website uses cookies. Please decide for yourself, which kind of cookies you want to allow. You will find further information in our <LinkLikeText onClick={props.onLinkClick} key="link">data privacy</LinkLikeText>.
                    </Trans>
                }
            </Typography>
        );
    }
);
